import type {ViewsResult, ViewsStore} from './viewsTypes'

export const extractViewsFromResponse = (res: ViewsResult): ViewsStore => res.namespaces
